import React, { Component } from 'react';
import classnames from 'classnames';
import { withSnackbar } from 'notistack';

import {
	getLimitsValues,
	uploadThresholdsValues,
	downloadTemplate,
} from 'services/threshold.service';
import withStyles from '@material-ui/core/styles/withStyles';

import { canByLicensing } from 'utils/licensing/licensingChecker';

import SnackMessage from 'components/Snackbar/SnackMessage';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import CsvUpload from 'components/CustomUpload/CsvUpload';
import Button from 'components/CustomButtons/Button';

import { thresholdsValues as styles } from 'assets/jss/material-dashboard-pro-react/views/thresholdsStyles';

class ThresholdsValues extends Component {
	state = {
		isLoading: false,
		values: [],
	};

	componentDidMount() {
		this.getValues();
	}

	headers = [
		'Name',
		'Set Critical',
		'Set Major',
		'Set Minor',
		'Clear Critical',
		'Clear Major',
		'Clear Minor',
		'Active',
	];

	showToastMessage = (message, color = 'danger') => {
		this.props.enqueueSnackbar(message, {
			content: (key, message) => <SnackMessage id={key} message={message} color={color} />,
		});
	};

	getValues = async () => {
		this.setState({ isLoading: true });
		try {
			const values = await getLimitsValues();
			this.setState({ values });
		} catch (error) {
			this.showToastMessage(error.resolvedErrorMessage);
		}
		this.setState({ isLoading: false });
	};

	onCsvLoad = async (file) => {
		this.setState({ isLoading: true });
		try {
			await uploadThresholdsValues(file);
			this.getValues();
			this.showToastMessage('The Thresholds have been updated successfully!', 'success');
		} catch (error) {
			this.showToastMessage(error.resolvedErrorMessage);
		}
		this.setState({ isLoading: false });
	};

	render() {
		const { classes } = this.props;
		const loadingIndicator = this.state.isLoading ? (
			<div className={classes.loadingIndicatorWrapper}>
				<LoadingIndicator />
			</div>
		) : null;
		const noResultsFoundText =
			!this.state.isLoading && this.state.values.length === 0 ? (
				<div className={classes.noResultsFound}>No Results Found</div>
			) : null;

		const headers = this.headers.map((header, index) => {
			return (
				<th
					key={index}
					className={classnames(
						'rt-th rt-resizable-header',
						index === 0 ? classes.thName : classes.th
					)}
				>
					{header}
				</th>
			)
		});

		return (
			<div className={classes.wrapper}>
				{ canByLicensing('analytics.customizeThresholds') &&
					<div>
						<CsvUpload
							onLoad={this.onCsvLoad}
							label="Upload Thresholds Values"
							dialogTitle="Upload Thresholds Values"
						/>
						<Button
							size="sm"
							color="warning"
							onClick={downloadTemplate}
							className={classes.downloadTemplateButton}
						>
							{'Download Template'}
						</Button>
						<div className={classes.uploadCsvInfo}>
							{'Please, upload CSV File with new Thresholds Values. For correct work of the File - do not change Threshold IDs values.'}
						</div>
					</div>
				}
				{loadingIndicator}
				<div className="ReactTable -striped -highlight">
					<table className="rt-table">
						<thead className="rt-thead -header">
							<tr className={classnames('rt-tr')}>
								{headers}
							</tr>
						</thead>
						<tbody className="rt-tbody">
							{this.state.values.map(
								({ id, name, setCritical, setMajor, setMinor, clearCritical, clearMajor, clearMinor, active }, index) => (
									<tr
										key={id}
										className={classnames(
											'rt-tr',
											{ ' -odd': index % 2 === 0 },
											{ ' -even': index % 2 === 1 }
										)}
									>
										<td
											className={classnames(
												'rt-td',
												classes.tdName
											)}
										>
											{name}
										</td>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{setCritical}
										</td>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{setMajor}
										</td>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{setMinor}
										</td>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{clearCritical}
										</td>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{clearMajor}
										</td>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{clearMinor}
										</td>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{active ? 'Yes' : 'No'}
										</td>
									</tr>
								)
							)}
						</tbody>
					</table>
				</div>
				{noResultsFoundText}
			</div>
		);
	}
}

export default withStyles(styles)(withSnackbar(ThresholdsValues));
